import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import type { IError } from "@litres-libs/types";
import { addHydrateReducer } from "../../utils/hydrateReducer";

export interface ILastViewedArt {
  artId: number;
  artName: string;
  authorName: string;
  isFakeAuthor: boolean;
  personId: number;
  mem: string;
  cover: string;
}

export interface ILastViewedBooksWidgetState {
  arts: ILastViewedArt[];
  isLoading?: boolean;
  error?: IError | null;
}

const initialState: ILastViewedBooksWidgetState = {
  arts: [],
  isLoading: false,
  error: null,
};

export const lastViewedBooksWidgetSlice = createSlice({
  name: "global/lastViewedBooksWidget",
  initialState,
  reducers: {
    setLastViewedWidgetData: (
      state: ILastViewedBooksWidgetState,
      action: PayloadAction<ILastViewedBooksWidgetState>
    ) => {
      return {
        ...state,
        ...action.payload,
      };
    },
  },
  extraReducers: builder => {
    addHydrateReducer(builder, "global.lastViewedBooksWidget");
  },
});

export const { setLastViewedWidgetData } = lastViewedBooksWidgetSlice.actions;

export default lastViewedBooksWidgetSlice.reducer;
